module.exports = __webpack_public_path__ + "media/logos/Citizen M-1e651bce.svg";